import type { SitePageSection } from "@/lib/site-pages-server";

/** Public URL for the games hub site page (`section === "games"`). */
export const GAMES_HUB_PATH = "/games";

/**
 * Public URL for a published site page.
 * Topic pages live at `/pages/[slug]`; the games hub stays at `/games`.
 */
export function getSitePagePublicPath(
  section: SitePageSection | string,
  slug: string | null
): string {
  if (section === "games") return GAMES_HUB_PATH;
  if (section === "topics" && slug) return `/pages/${slug}`;
  return "#";
}

/** Staff-only preview of a topic page as saved, published or not. */
export function getSitePagePreviewPath(slug: string): string {
  return `/preview/pages/${slug}`;
}

export interface SitePageViewLink {
  href: string;
  /** True for the staff preview of a draft; false for the public URL. */
  preview: boolean;
}

/** Where "View" goes for a saved page: its public URL, or its staff preview while a draft. */
export function getSitePageViewLink(
  page: { section: SitePageSection | string; slug: string | null; published: boolean },
  canPreviewUnpublished: boolean
): SitePageViewLink | null {
  if (page.published) {
    const href = getSitePagePublicPath(page.section, page.slug);
    return href === "#" ? null : { href, preview: false };
  }
  if (page.section === "topics" && page.slug && canPreviewUnpublished) {
    return { href: getSitePagePreviewPath(page.slug), preview: true };
  }
  return null;
}

/** Legacy topic URL at `/games/[slug]` (permanent redirect target is `/pages/[slug]`). */
export function getLegacyTopicGamesPath(slug: string): string {
  return `/games/${slug}`;
}
